export default "<div class=\"indicator\" #indicator></div>\r\n"